import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

const LINKS = [
  { label: "The Books", href: "#chapter-01" },
  { label: "Ad Studio", href: "#ad-studio" },
  { label: "Publisher", href: "#publisher" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={clsx(
        "fixed inset-x-0 top-0 z-[80] transition-[background-color,border-color,backdrop-filter] duration-500",
        scrolled
          ? "border-b border-white/10 bg-[#0c0a09]/60 shadow-[0_8px_32px_rgba(0,0,0,0.5)] backdrop-blur-2xl"
          : "border-b border-transparent bg-transparent"
      )}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a href="#top" data-testid="header-logo" className="group flex items-baseline gap-2">
          <span className="font-serif text-xl font-bold tracking-tight text-[#F4F4F0]">
            Samkhya
          </span>
          <span className="font-sans text-[10px] font-semibold uppercase tracking-[0.3em] text-[#A8A29E] transition-colors duration-300 group-hover:text-[#E63946]">
            Publishing
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-[#A8A29E] transition-colors duration-300 hover:text-[#F4F4F0]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#chapter-01"
          data-testid="header-buy-button"
          className="border border-[#E63946] px-4 py-2 font-sans text-[10px] font-bold uppercase tracking-[0.25em] text-[#E63946] transition-colors duration-300 hover:bg-[#E63946] hover:text-white"
        >
          Buy the books
        </a>
      </div>
    </motion.header>
  );
};
